<script setup>
import { ref, onMounted, defineEmits, defineProps, watch } from "vue";
import ERP from "@apiV2/ERP.mjs"
import View from "@apiV2/View.mjs";
import UtilMoney from "@/utils/UtilMoney";
import NotaFiscalService from "@/api/v2/services/NotaFiscalService";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "controlesDesativados",
    "visualizandoDadoNotaFiscalEmitida",
    "visualizandoDadoContaAReceberAvulsa",
    "gerandoRecebimentos",
    "vincularNotaFiscal",
    "dados",
    "dado",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraVisualizandoDadoNotaFiscalEmitida",
    "update:alteraVisualizandoDadoContaAReceberAvulsa",
    "update:alteraGerandoRecebimentos",
    "update:alteraVincularNotaFiscal",
    "update:alteraDados",
    "update:alteraContasFinanceiras",
    "update:alteraNotasFiscaisVinculaveis"
]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//========== Altera Visualizando Dado Nota Fiscal Emitida ==========//
//==================================================================//

const alteraVisualizandoDadoNotaFiscalEmitida = (update)=>{

    emits('update:alteraVisualizandoDadoNotaFiscalEmitida',update);

};

//==================================================================//
//======== Altera Visualizando Dado Conta a Receber Avulsa =========//
//==================================================================//

const alteraVisualizandoDadoContaAReceberAvulsa = (update)=>{

    emits('update:alteraVisualizandoDadoContaAReceberAvulsa',update);

};

//==================================================================//
//================== Altera Gerando Recebimento ====================//
//==================================================================//

const alteraGerandoRecebimentos = (update)=>{

    emits('update:alteraGerandoRecebimentos',update);

};

//==================================================================//
//================== Altera Vincular Nota Fiscal ===================//
//==================================================================//

const alteraVincularNotaFiscal = (update)=>{

    emits('update:alteraVincularNotaFiscal',update);

};


//==================================================================//
//======================== Dados Loading ===========================//
//==================================================================//

const dadosLoading = ref(true);

//==================================================================//
//================== Contas Financeiras Loading ====================//
//==================================================================//

const contasFinanceirasLoading = ref(false);

//==================================================================//
//===================== Notas Fiscais Loading ======================//
//==================================================================//

const notasFiscaisLoading = ref(false);

//==================================================================//
//================= Dado Selecionado Numero Busca ==================//
//==================================================================//

let dadoSelecionadoNumeroBusca = ref("");

//==================================================================//
//=================== Dado Selecionado Job Busca ====================//
//==================================================================//

let dadoSelecionadoJobBusca = ref("");

//==================================================================//
//=============== Dado Selecionado Cliente Busca ===================//
//==================================================================//

let dadoSelecionadoClienteBusca = ref("");

//==================================================================//
//======================== Altera Dados ============================//
//==================================================================//

const alteraDados = (update)=>{

    emits('update:alteraDados',update);

};

//==================================================================//
//================== Altera Contas Financeiras =====================//
//==================================================================//

const alteraContasFinanceiras = (update)=>{

    emits('update:alteraContasFinanceiras',update);

};

//==================================================================//
//=============== Altera Notas Fiscais Vinculaveis =================//
//==================================================================//

const alteraNotasFiscaisVinculaveis = (update)=>{

    emits('update:alteraNotasFiscaisVinculaveis',update);

};

//==================================================================//
//================= Filtra Pelo Numero do Dado =====================//
//==================================================================//

const filtraPeloNumeroDoDado = (numeroDoDado) =>{

    if(!dadoSelecionadoNumeroBusca.value){
        return true;
    }
    
    return numeroDoDado.toLowerCase().includes(dadoSelecionadoNumeroBusca?.value?.numero?.toLowerCase());

}

//==================================================================//
//================== Filtra Pelo Job do Dado =======================//
//==================================================================//

const filtraPeloJobDoDado = (jobCodigo) =>{

    if(!dadoSelecionadoJobBusca.value){
        return true;
    }
    
    return jobCodigo.toLowerCase().includes(dadoSelecionadoJobBusca?.value?.job?.codigo?.toLowerCase());

}

//==================================================================//
//==================== Filter Cliente do Dado ======================//
//==================================================================//

const filtraPeloClienteDoDado = (clieteNome) =>{

    if(!dadoSelecionadoClienteBusca.value){
        return true;
    }

    return clieteNome.toLowerCase().includes(dadoSelecionadoClienteBusca?.value?.cliente?.nome?.toLowerCase());

}

//==================================================================//
//========================= Dados Headers ==========================//
//==================================================================//

let dadosHeaders = [
    { text: '',                                     value: 'controles',                 class:"c-dado__header",    cellClass:'c-dado__cell', sortable: false},
    { text: 'N°',                                   value: 'numero',                    class:"c-dado__header",    cellClass:'c-dado__cell', filter: filtraPeloNumeroDoDado},
    { text: 'Job',                                  value: 'job.codigo',                class:"c-dado__header",    cellClass:'c-dado__cell', filter: filtraPeloJobDoDado},
    { text: 'Cliente',                              value: 'cliente.nome',              class:"c-dado__header",    cellClass:'c-dado__cell', filter: filtraPeloClienteDoDado}, 
    { text: 'Valor Original',                       value: 'valorOriginal',             class:"c-dado__header",    cellClass:'c-dado__cell'},
    { text: 'Valor Liquidado',                      value: 'valorRecebido',             class:"c-dado__header",    cellClass:'c-dado__cell'},
    { text: 'Valor a Liquidar',                     value: 'valorParaReceber',          class:"c-dado__header",    cellClass:'c-dado__cell'},
    { text: 'Contas a Receber',                     value: 'contasAReceberQuantidade',  class:"c-dado__header",    cellClass:'c-dado__cell'},
    { text: 'Recebimentos das Contas a Receber',    value: 'recebimentosQuantidade',    class:"c-dado__header",    cellClass:'c-dado__cell'},
]

//==================================================================//
//=========================== Load Dados ===========================//
//==================================================================//

const loadDados = async () =>{

    dadosLoading.value = true;
    alteraControlesDesativados(true);

    const dadosResponse = await ERP.getManyWithView(View.CONTAS_A_RECEBER);
    
    alteraDados(dadosResponse.data)

    alteraControlesDesativados(false);
    dadosLoading.value = false;

};

//==================================================================//
//===================== Load Contas Financeiras ====================//
//==================================================================//

const loadContasFinanceiras = async () =>{

    contasFinanceirasLoading.value = true;
    alteraControlesDesativados(true);

    const contasFinanceirasResponse = await ERP.getManyWithView(View.CONTAS_A_RECEBER_CONTAS_FINANCEIRAS);
    
    alteraContasFinanceiras(contasFinanceirasResponse.data)

    alteraControlesDesativados(false);
    contasFinanceirasLoading.value = false;

};

//==================================================================//
//================= Load Notas Fiscais Vinculaveis =================//
//==================================================================//

const loadNotasFiscaisVinculaveis = async (dado) =>{

    notasFiscaisLoading.value = true;
    alteraControlesDesativados(true);
    
    const notasFiscaisVinculaveisResponse = await ERP.getManyWithView(View.CONTAS_A_RECEBER_NOTAS_FISCAIS_VINCULAVEIS,[
        {
            name: "job",
            dataType: "String",
            value: dado?.job?.id
        },
    ]);

    alteraNotasFiscaisVinculaveis(notasFiscaisVinculaveisResponse.data);

    alteraControlesDesativados(false);
    notasFiscaisLoading.value = false;

};

//==================================================================//
//============ Ao Visualizar Dado Nota Fiscal Emitida ==============//
//==================================================================//

const aoVisualizarDadoNotaFiscalEmitida = (dado)=>{

    alteraVisualizandoDadoNotaFiscalEmitida({
        visualizandoDadoNotaFiscalEmitida: true,
        dado: dado
    });

}

//==================================================================//
//========= Ao Visualizar Dado Conta a Receber Avulsa ==============//
//==================================================================//

const aoVisualizarDadoContaAReceberAvulsa = (dado)=>{

    alteraVisualizandoDadoContaAReceberAvulsa({
        visualizandoDadoContaAReceberAvulsa: true,
        dado: dado
    });

}

//==================================================================//
//==================== Ao Gerar Recebimentos =======================//
//==================================================================//

const aoGerarRecebimentos = async (dado)=>{

    await loadContasFinanceiras();

    alteraGerandoRecebimentos({
        gerandoRecebimentos: true,
        dado: dado
    });

}

//==================================================================//
//==================== Ao Vincular Nota Fiscal =====================//
//==================================================================//

const aoVincularNotaFiscal = async (dado)=>{

    await loadNotasFiscaisVinculaveis(dado);

    alteraVincularNotaFiscal({
        vincularNotaFiscal: true,
        dado: dado
    });

}

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

    await loadDados();

});

//==================================================================//
//===== Watch => visualizandoDadoNotaFiscalEmitida =================//
//==================================================================//

watch(()=> props.visualizandoDadoNotaFiscalEmitida, () => {

    if(props.visualizandoDadoNotaFiscalEmitida == false){
        loadDados();
    }

});

//==================================================================//
//===== Watch => visualizandoDadoContaAReceberAvulsa ===============//
//==================================================================//

watch(()=> props.visualizandoDadoContaAReceberAvulsa, () => {

    if(props.visualizandoDadoContaAReceberAvulsa == false){
        loadDados();
    }

});

//==================================================================//
//================== Watch => gerandoRecebimentos ==================//
//==================================================================//

watch(()=> props.gerandoRecebimentos, () => {

    if(props.gerandoRecebimentos == false){
        loadDados();
    }

});

//==================================================================//
//================== Watch => vincularNotaFiscal ===================//
//==================================================================//

watch(()=> props.vincularNotaFiscal, () => {

    if(props.vincularNotaFiscal == false){
        loadDados();
    }

});

//==================================================================//
//========= Mostra Visualizar Dado Nota Fiscal Emitida =============//
//==================================================================//

const mostraVisualizarDadoNotaFiscalEmitida = (dado) =>{

    if(dado?.origem == "Nota Fiscal Emitida"){
        return true;
    }

    return false;

};

//==================================================================//
//========== Mostra Visualizar Conta a Receber Avulsa ==============//
//==================================================================//

const mostraVisualizarContaAReceberAvulsa = (dado) =>{

    if(dado?.origem == "Conta a Receber Avulsa"){
        return true;
    }

    return false;

};

//==================================================================//
//============= Mostra Baixar Nota Fiscal Emitida ==================//
//==================================================================//

const mostraBaixarNotaFiscalEmitida = (dado) =>{

    if(dado?.origem == "Nota Fiscal Emitida"){
        return true;
    }

    return false;

};

//==================================================================//
//================== Baixar Nota Fiscal Emitida ====================//
//==================================================================//

const baixarNotaFiscalEmitida = async (notaFiscalEmitida)=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: notaFiscalEmitida.chaveAcesso,
        plugNotasId: notaFiscalEmitida.plugNotasID
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

//==================================================================//
//==================== Mostra Gerar Recebimentos ===================//
//==================================================================//

const mostraGerarRecebimentos = (dado) =>{

    if(dado?.origem != "Nota Fiscal Emitida"){
        return false;
    }

    return true;

};

//==================================================================//
//==================== Mostra Vincular Nota Fiscal ===================//
//==================================================================//

const mostraVincularNotaFiscal = (dado) =>{

    if(dado?.origem != "Conta a Receber Avulsa"){
        return false;
    }

    return true;

};

</script>

<template>

    <v-card
        class="c-dados"
    >

        <v-card-title
            class="c-dados__header"
        >

            <h3
                class="c-header__titulo"
            >
                
            </h3>

            <div
                class="c-header__buscas"
            >

                <div class="c-busca c-busca--numero-do-dado">

                    <v-autocomplete
                        label="N°"
                        class="c-busca__input"
                        v-model="dadoSelecionadoNumeroBusca"
                        :items="props.dados"
                        item-text="numero"
                        hide-details
                        outlined
                        return-object
                        clearable
                    >

                        <template v-slot:item="{ item }">
                            <span><strong>{{item.sigla}}: </strong><span>{{item.numero}}</span></span>
                        </template>

                        <template v-slot:selection="{ item }">
                            <span><strong>{{item.sigla}}: </strong><span>{{item.numero}}</span></span>
                        </template>

                    </v-autocomplete>

                </div>

                <div class="c-busca c-busca--job-do-dado">

                    <v-autocomplete
                        label="Job"
                        class="c-busca__input"
                        v-model="dadoSelecionadoJobBusca"
                        :items="props.dados"
                        item-text="job.codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                    >

                        <template v-slot:item="{ item }">
                            {{item?.job?.codigo}}
                        </template>

                        <template v-slot:selection="{ item }">
                            {{item?.job?.codigo}}
                        </template>

                    </v-autocomplete>

                </div>

                <div class="c-busca c-busca--cliente-do-dado">

                    <v-autocomplete
                        label="Cliente"
                        class="c-busca__input"
                        v-model="dadoSelecionadoClienteBusca"
                        :items="props.dados"
                        item-text="cliente.nome"
                        hide-details
                        outlined
                        return-object
                        clearable
                    >

                        <template v-slot:item="{ item }">
                            {{item?.cliente?.nome}}
                        </template>

                        <template v-slot:selection="{ item }">
                            {{item?.cliente?.nome}}
                        </template>

                    </v-autocomplete>

                </div>

            </div>

            <v-chip
                class="c-header__usuario"
                label
            >

                <v-icon left>
                    mdi-account-circle-outline
                </v-icon>
                Usuario:
                {{colaboradorStore?.colaborador?.nome}}

            </v-chip>

        </v-card-title>

        <v-data-table
            class="c-dados__tabela elevation-1"
            :headers="dadosHeaders"
            :items="props.dados"
            :items-per-page="-1"
            select-strategy="all"
            item-key="id"
            return-object
            :loading="dadosLoading"
            loading-text="Carregando... Por favor, aguarde."
        >

            <template v-slot:item.controles="{ item }">

                <div
                    class="c-controles"
                >

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                v-show="mostraVisualizarDadoNotaFiscalEmitida(item)"
                                class="c-visualizar-dados-nota-fiscal-emitida mx-2"
                                fab
                                dark
                                small
                                color="#32434D"
                                v-bind="attrs"
                                v-on="on"
                                @click="aoVisualizarDadoNotaFiscalEmitida(item)"
                            >

                                <v-icon dark>
                                    mdi-eye
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>
                            Visualizar Nota Fiscal Emitida
                        </span>

                    </v-tooltip>

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                v-show="mostraVisualizarContaAReceberAvulsa(item)"
                                class="c-visualizar-dados-conta-a-receber-avulsa mx-2"
                                fab
                                dark
                                small
                                color="#32434D"
                                v-bind="attrs"
                                v-on="on"
                                @click="aoVisualizarDadoContaAReceberAvulsa(item)"
                            >

                                <v-icon dark>
                                    mdi-eye
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>
                            Visualizar Adiantamento
                        </span>

                    </v-tooltip>

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                v-show="mostraBaixarNotaFiscalEmitida(item)"
                                class="c-baixar-nota-fiscal-emitida mx-2"
                                fab
                                dark
                                small
                                color="#3E737B"
                                v-bind="attrs"
                                v-on="on"
                                @click="baixarNotaFiscalEmitida(item)"
                            >

                                <v-icon dark>
                                    mdi-download
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>
                            Baixar Nota Fiscal Emitida
                        </span>

                    </v-tooltip>

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                v-show="mostraGerarRecebimentos(item)"
                                :disabled="!item?.podeGerarRecebimentos"
                                class="c-gerar-recebimentos mx-2"
                                fab
                                dark
                                small
                                color="#4F6563"
                                v-bind="attrs"
                                v-on="on"
                                @click="aoGerarRecebimentos(item)"
                            >

                                <v-icon dark>
                                    mdi-cash-plus
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>
                            Gerar Recebimentos
                        </span>

                    </v-tooltip>

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                v-show="mostraVincularNotaFiscal(item)"
                                :disabled="!item?.podeGerarVinculos"
                                class="c-vincular-nota-fiscal mx-2"
                                fab
                                dark
                                small
                                color="#4F6563"
                                v-bind="attrs"
                                v-on="on"
                                @click="aoVincularNotaFiscal(item)"
                            >

                                <v-icon dark>
                                    mdi-link-variant-plus
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>
                            Vincular Nota Fiscal
                        </span>

                    </v-tooltip>

                </div>

            </template>

            <template v-slot:item.numero="{ item }">

                <span><strong>{{item.sigla}}: </strong><span>{{item.numero}}</span></span>

            </template>

            <template v-slot:item.clienteNome="{ item }">

                {{item.clienteNome}}

            </template>

            <template v-slot:item.valorOriginal="{ item }">

                R$ {{UtilMoney.toBRL(item?.valorOriginal)}}

            </template>

            <template v-slot:item.valorRecebido="{ item }">

                R$ {{UtilMoney.toBRL(item?.valorRecebido)}}

            </template>

            <template v-slot:item.valorParaReceber="{ item }">

                R$ {{UtilMoney.toBRL(item?.valorParaReceber)}}

            </template>

            <template v-slot:item.contasAReceberQuantidade="{ item }">

                <v-chip
                    color="indigo"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-receipt-text
                    </v-icon>
                    {{item?.contasAReceberQuantidade}}

                </v-chip>

            </template>

            <template v-slot:item.recebimentosQuantidade="{ item }">

                <v-chip
                    color="primary"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-cash-multiple
                    </v-icon>
                    {{item?.recebimentosQuantidade}}

                </v-chip>

            </template>

        </v-data-table>

    </v-card>

</template>

<style scoped>

.c-dados__header{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo titulo"
    "buscas usuario";
    gap: 10px;
    align-items: start;
}

.c-header__titulo{
    grid-area: titulo;
}

.c-header__buscas{
    grid-area: buscas;
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr max-content; 
    gap: 10px;
    grid-template-areas: 
        "buscaNumeroDoDado buscaJobDoDado"
        "buscaClienteDoDado buscaClienteDoDado";
}

.c-busca > .c-busca__texto{
    margin: 0;
    font-size: 14px;
}

.c-busca--toogle{
    align-items: center;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
}

.c-busca--toogle > .c-busca__input{
    padding-left: 10px;
}

.c-busca-input__item--espaco{
    padding: 10px
}

.c-busca--numero-do-dado{
    grid-area: buscaNumeroDoDado;
}

.c-busca--job-do-dado{
    grid-area: buscaJobDoDado;
}

.c-busca--cliente-do-dado{
    grid-area: buscaClienteDoDado;
}

.c-header__usuario{
    grid-area: usuario;
    margin: 0 20px;
    min-height: 48px;
}

.c-header__usuario >>> .v-chip__content{
    margin: auto;
}

.c-dados__tabela{
    display: grid;
    white-space: nowrap;
}

.c-controles{
    display: flex;
    gap: 10px;
}

/*==================================================================*/
/*=================== Botões de Notas Fiscais ======================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-dado-nota-fiscal-emitida{
    background: #32434D !important;
    border-color: #32434D !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-baixar-nota-fiscal-emitida{
    background: #3E737B !important;
    border-color: #3E737B !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-gerar-recebimentos{
    background: #4F6563 !important;
    border-color: #4F6563 !important;
}

/*==================================================================*/
/*============== Botões de Conta a Receber Avulsa ==================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-dados-conta-a-receber-avulsa{
    background: #32434D !important;
    border-color: #32434D !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-vincular-nota-fiscal{
    background: #4F6563 !important;
    border-color: #4F6563 !important;
}

/*==================================================================*/
/*==================================================================*/
/*==================================================================*/

.c-dados__tabela >>> .c-dado__cell{
    padding: 16px !important;
}

@media (width <= 850px) {
    
    .c-dados__header{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "usuario"
            "buscas";
    }

    .c-header__usuario{
        margin: 0;
    }

    .c-header__buscas { 
        grid-area: buscas;
        display: grid; 
        grid-template-columns: 1fr; 
        grid-template-rows: max-content max-content max-content; 
        gap: 10px; 
        grid-template-areas: 
            "buscaNumeroDoDado"
            "buscaJobDoDado"
            "buscaClienteDoDado";
    }

    /*
        grid-template-columns: 1fr 1fr; 
        grid-template-rows: 1fr max-content; 
        gap: 10px;
        grid-template-areas: 
            "buscaNumeroDoDado buscaJobDoDado"
            "buscaClienteDoDado buscaClienteDoDado";
    */

}

</style>
